import {systemConfig} from "./systemConfig";

export const modalConfig = {
    dataType: {
        menuType: systemConfig.dataType.menuType,
        userType: systemConfig.dataType.userType,
        eventType: systemConfig.dataType.eventType
    }
}
